import moment from 'moment-timezone'

export const DEFAULT_TIME_ZONE = 'America/Vancouver'

export function locationTimeZone(location) {
  const zone = location && location.timeZone
  return typeof zone === 'string' && moment.tz.zone(zone) ? zone : DEFAULT_TIME_ZONE
}

export function restaurantMoment(value, timeZone = DEFAULT_TIME_ZONE) {
  return moment(value).tz(locationTimeZone({ timeZone }))
}

// Stored schedule timestamps represent recurring clock times in this location.
export function isOpenForGivenTime({ hours, targetDate, time, waitTime = 0, timeZone }) {
  const day = restaurantMoment(targetDate, timeZone)
  const schedule = (hours || {})[day.day()] || {}
  if (!schedule.open || !schedule.close) return false
  const at = value => {
    const clock = restaurantMoment(value, timeZone)
    return day.clone().hour(clock.hour()).minute(clock.minute()).second(0).millisecond(0)
  }
  const open = at(schedule.open)
  const close = at(schedule.close)
  if (open.isSame(close)) return false
  if (close.isBefore(open)) close.add(1, 'day')
  return restaurantMoment(time, timeZone).isBetween(open, close.subtract(waitTime, 'minutes'))
}

// Date picker values describe calendar dates, independent of the computer's zone.
export function reportRange(fromDate, toDate, timeZone = DEFAULT_TIME_ZONE) {
  const zone = locationTimeZone({ timeZone })
  return {
    fromDate: moment.tz(fromDate.format('YYYY-MM-DD'), zone).startOf('day'),
    toDate: moment.tz(toDate.format('YYYY-MM-DD'), zone).startOf('day').add(1, 'day'),
  }
}
